export default __webpack_public_path__ + "static/media/tile-3-long.9841fe72.png";